export default __webpack_public_path__ + "static/media/children-illustration.bc053f19.svg";